import "./ToiletProblems.module.css";
import Header from "@/reusable_sections/Header";
import ToiletHero from "./sections/ToiletHero";
import ToiletSymptoms from "./sections/ToiletSymptoms";
import EmergencyCta from "./sections/EmergencyCta";
import Footer from "@/reusable_sections/Footer";
export default function ToiletProblemsPage() {
  return <div>
      <Header />
      <ToiletHero />
      <ToiletSymptoms />
      <EmergencyCta />
      <Footer />
    </div>;
}